/* istanbul ignore file */

/**
 * Should have all locale keys used in this project with translations matching the language-region
 * code of this file.
 */
export default {
  apply: 'Apply',
  cancel: 'Cancel',
  chooseDate: 'Choose date',
  chooseDateRange: 'Choose date range',
  closePopup: 'Close Popup',
  customRange: 'Custom Range',
  fri: 'F',
  friday: 'Friday',
  inSelectedRange: 'in selected range',
  inputLabel: 'Date picker Input',
  mon: 'M',
  monday: 'Monday',
  month1: 'Jan',
  month10: 'Oct',
  month11: 'Nov',
  month12: 'Dec',
  month2: 'Feb',
  month3: 'Mar',
  month4: 'Apr',
  month5: 'May',
  month6: 'June',
  month7: 'July',
  month8: 'Aug',
  month9: 'Sept',
  nextMonth: 'Next Month',
  prevMonth: 'Previous Month',
  sat: 'S',
  saturday: 'Saturday',
  selectedDate: 'selected date',
  selectedEndDate: 'selected end date',
  selectedStartDate: 'selected start date',
  sun: 'S',
  sunday: 'Sunday',
  thu: 'T',
  thursday: 'Thursday',
  tue: 'T',
  tuesday: 'Tuesday',
  wed: 'W',
  wednesday: 'Wednesday',
  weekHeader: 'W',
  weekHeaderNumber: 'Week Number',
};
